import type {AssetConfigurationDto} from '@hconnect/kilnfeature/src/types'
import {createContext, useContext} from 'react'

import type {DrillingSettingsDTO} from '../types'

interface KilnSettingsContext {
  kilnConfig: AssetConfigurationDto
  drillingSettings: DrillingSettingsDTO
}

const KilnSettingsContext = createContext<KilnSettingsContext | undefined>(undefined)

export const useKilnSettings = () => {
  const context = useContext(KilnSettingsContext)
  if (!context) throw new Error('useKilnSettings is used outside of the KilnSettingsProvider!')
  return context
}

interface KilnSettingsProviderProps {
  kilnConfig: AssetConfigurationDto
  drillingSettings: DrillingSettingsDTO
  children: React.ReactNode
}

export const KilnSettingsProvider: React.FC<KilnSettingsProviderProps> = ({
  kilnConfig,
  drillingSettings,
  children
}) => {
  return (
    <KilnSettingsContext.Provider value={{kilnConfig, drillingSettings}}>
      {children}
    </KilnSettingsContext.Provider>
  )
}
